// import AppNavbar from "./AppNavbar";
import AppLayout from "./AppLayout";
import Footer from "./Footer";
import '../../assets/css/profile.scss'
import profileImg from '../../assets/images/man.png'
import ProfileAddressEditModal from "./ProfileAddressEditModal";
import { useEffect, useState } from "react";
import { loadProfileData } from "../redux/action";
import { useDispatch, useSelector } from "react-redux";

const Profile = () => {

    const dispatch = useDispatch();
    const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails"));
    const signInID = signInDetails[0]?.id;

    const { profileData } = useSelector((state) => state.data);
    const [showAddressModal, setShowAddressModal] = useState(false);
    const [loading, setLoading] = useState(false);

    const fetchProfileData = () => {
        dispatch(loadProfileData(signInID, setLoading))
    }

    useEffect(() => {
        fetchProfileData();
    }, [])

    const endDate = new Date(profileData.end_date);
    const today = new Date();

    endDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    const diffTime = endDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return (
        <div className="page-layout">
            {/* <AppNavbar /> */}
            <AppLayout>
            <div className="page-content">
                <div className="profile-details-container">
                    <h5>Profile</h5>
                    <div className="profile-details-div">
                        <div className="profile-detaills-first-div">
                            <div className="profile-name-img">
                                <img src={profileImg} className="profile-img" />
                                <div className="profile-div">
                                    <h6>{profileData?.name}</h6>
                                    <p>{profileData?.sbn_id}</p>
                                </div>
                            </div>
                            <div className="about-div">
                                <strong className="mb-2">About</strong>
                                <div className="d-flex align-items-start flex-column">
                                    <p> <i class="fa-solid fa-phone"></i> &nbsp;Phone : <span>{profileData?.phone}</span></p>
                                    <p> <i class="fa-solid fa-envelope"></i> &nbsp;Email : <span>{profileData?.email}</span></p>
                                </div>
                            </div>
                            <hr />
                            <div className="about-div">
                                <strong className="mb-2">Address &nbsp;
                                    <i
                                        className="fa-solid fa-pen-to-square edit-icon"
                                        onClick={() => setShowAddressModal(true)}
                                        style={{ cursor: 'pointer', fontSize: '18px', color: '#0d6efd' }}
                                    ></i>
                                </strong>
                                {profileData?.addresses?.length > 0 && (
                                    <div className="d-flex align-items-start flex-column">
                                        <p>
                                            <i className="fa-solid fa-location-arrow"></i> &nbsp;Address :{" "}
                                            <span>
                                                {profileData.addresses[0].address_line_1},&nbsp;
                                                {profileData.addresses[0].address_line_2}
                                            </span>
                                        </p>
                                        <p>
                                            <i className="fa-solid fa-city"></i> &nbsp;City :{" "}
                                            <span>
                                                {profileData.addresses[0].admin_area_2},&nbsp;
                                                {profileData.addresses[0].admin_area_1},&nbsp;
                                                {profileData.addresses[0].country}
                                            </span>
                                        </p>
                                        <p>
                                            <i className="fa-solid fa-location-dot"></i> &nbsp;Postcode :{" "}
                                            <span>{profileData.addresses[0].postal_code}</span>
                                        </p>
                                    </div>
                                )}
                            </div>
                            <hr />
                            <div className="about-div">
                                <strong className="mb-2">Employee Details</strong>
                                <div className="d-flex align-items-start flex-column">
                                    <p> <i class="fa-solid fa-calendar"></i> &nbsp;Company : <span>{profileData?.company_name}</span></p>
                                    <p> <i class="fa-solid fa-briefcase"></i> &nbsp;Subscription End : <span>{profileData?.end_date}</span></p>
                                    <p> <i class="fa-solid fa-briefcase"></i> &nbsp;Days Remained : <span> {diffDays >= 0 ? `${diffDays} days remaining` : `${Math.abs(diffDays)} days ago`}</span></p>
                                </div>
                            </div>
                        </div>
                        <div className="profile-detaills-second-div">
                            <h6 className="title-header mt-3">Job Information</h6>
                            {profileData?.purchased_items?.length > 0 ? (
                                <table className="table table-bordered text-start mt-3">
                                    <thead className="table-light">
                                        <tr>
                                            <th>Item Name</th>
                                            <th>Plan</th>
                                            <th>Quantity</th>
                                            <th>Subscription Period</th>
                                            <th>Credits</th>
                                            <th>Available Credits</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{profileData.purchased_items[0].item_name}</td>
                                            <td>{profileData.purchased_items[0].plan}</td>
                                            <td>{profileData.purchased_items[0].quantity}</td>
                                            <td>{profileData.purchased_items[0].subscription_period}</td>
                                            <td>{profileData.purchased_items[0].Credits}</td>
                                            <td>{profileData?.Aval_credits}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            ) : (
                                <p>No purchased items found.</p>
                            )}
                            <div>
                                <h6 className="mt-3">Recent Activities</h6>
                                <div className="activity-cards-container mt-3">
                                    <div className="activity-card">
                                        <i className="fa-solid fa-clock"></i>
                                        <div>
                                            <p className="activity-title">Logged in</p>
                                            <small className="activity-time">Today at 9:45 AM</small>
                                        </div>
                                    </div>
                                    <div className="activity-card">
                                        <i className="fa-solid fa-file"></i>
                                        <div>
                                            <p className="activity-title">Uploaded report</p>
                                            <small className="activity-time">Yesterday at 3:22 PM</small>
                                        </div>
                                    </div>
                                    <div className="activity-card">
                                        <i className="fa-solid fa-pencil"></i>
                                        <div>
                                            <p className="activity-title">Updated profile</p>
                                            <small className="activity-time">July 28 at 5:14 PM</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ProfileAddressEditModal
                    show={showAddressModal}
                    handleClose={() => setShowAddressModal(false)}
                    fetchProfileData={fetchProfileData}
                    signInID={signInID}
                // onSubmit={handleUpdateAddress}
                />
            </div>
            </AppLayout>
            <Footer />
        </div>
    )
}
export default Profile;